import { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import ItemsList from "../../../components/ItemsList/ItemsList";
import {
  convertDate,
  formatDescription,
  formatDuration,
} from "../../Board/Board";
export default memo(function ExpiredSlaTasks({ tasks = [] }) {
  const tasksHeaders = useMemo(() => {
    return [
      {
        field: "date",
        headerName: "Date create",
        sortable: false,
        type: "string",
        maxWidth: 150,
        flex: 1,
        valueGetter: (params) => convertDate(params.row.asana_created_at),
      },
      {
        field: "name",
        headerName: "Number",
        sortable: false,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <>
            <Link to={item.row?.permalink_url} target="_blank">
              <span
                dangerouslySetInnerHTML={{
                  __html: formatDescription(item.value),
                }}
              />
            </Link>
          </>
        ),
      },
      {
        field: "notes",
        headerName: "Description",
        sortable: false,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatDescription(item.value),
            }}
          />
        ),
      },
      {
        field: "status",
        headerName: "Status",
        sortable: false,
        maxWidth: 100,
        flex: 1,
      },

      {
        field: "reporter",
        headerName: "Reporter",
        sortable: false,
        maxWidth: 200,
        flex: 1,
      },
      {
        field: "sla_first",
        headerName: "SLA first",
        sortable: false,
        type: "string",
        maxWidth: 150,
        flex: 1,
        renderCell: (params) =>
          formatDuration(params.row.sla?.first_comment_seconds ?? 0),
      },
      {
        field: "sla_in_progress",
        headerName: "SLA in progress",
        sortable: false,
        type: "string",
        maxWidth: 150,
        flex: 1,
        renderCell: (params) =>
          formatDuration(params.row.sla?.in_progress_seconds ?? 0),
      },
      {
        field: "sla_complete",
        headerName: "SLA complete",
        sortable: false,
        type: "string",
        maxWidth: 150,
        flex: 1,
        renderCell: (params) =>
          formatDuration(params.row.sla?.lifetime_seconds ?? 0),
      },
    ];
  }, []);

  return (
    <ItemsList
      items={tasks}
      headers={tasksHeaders}
      server={false}
      gridId="expored-sla-tasks"
      totalCount={tasks.length}
      defaultPageSize={20}
    />
  );
});
